/** @jsx jsx */
import { jsx } from "theme-ui"

import Logo from "./logo"
import NavBar from './navBar';


const Header = ({ children }) => (
  <header
    className="site-header"
  >
    <Logo />
    <NavBar/>
    {children}
  </header>
)

export default Header
